import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';
import { TunaCanBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/tuna'),
    loadMethod: MovieClip.animationLoader,
  },
});

export class TunaCanBlockView extends Container {
  constructor(props: TunaCanBlockProps) {
    super();

    blockPositionView(this, props);

    const movieclip = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.9,
    });

    movieclip.play('fish_state01');
  }

  public static assets() {
    return Object.values(manifest());
  }
}
